import _ from 'lodash';

export default function isFullEmptyObject(obj: object | null | undefined): boolean {
  if (obj === undefined || obj === null) return true;
  return Object.keys(_.omitBy(obj, _.isNull)).length === 0;
}
